import type { XYPosition } from 'react-flow-renderer';

import { getNodePositionId } from './getNodePositionId';

export const setNodePositionById = (
  workflowId: string,
  nodeId: string,
  position: XYPosition
): void => localStorage.setItem(getNodePositionId(workflowId, nodeId), JSON.stringify(position));
